// lib/authStorage.ts
// Sengaja dipisah dari authApi.ts (yang import axiosInstance) supaya
// axios.ts bisa import fungsi-fungsi ini tanpa circular dependency:
// axios.ts -> authStorage.ts (bukan axios.ts -> authApi.ts -> axios.ts)

export interface AuthUser {
  id: number;
  name: string;
  email: string;
  role: string;
}

const TOKEN_KEY = "auth_token";
const USER_KEY = "auth_user";

/**
 * @param remember - true: token disimpan permanen di localStorage (tetap
 * login walau browser ditutup). false: disimpan di sessionStorage saja
 * (hilang otomatis saat tab/browser ditutup).
 */
export const saveAuthSession = (token: string, user: AuthUser, remember: boolean) => {
  const storage = remember ? localStorage : sessionStorage;
  storage.setItem(TOKEN_KEY, token);
  storage.setItem(USER_KEY, JSON.stringify(user));
};

export const getAuthToken = () =>
  localStorage.getItem(TOKEN_KEY) ?? sessionStorage.getItem(TOKEN_KEY);

export const getAuthUser = (): AuthUser | null => {
  const raw = localStorage.getItem(USER_KEY) ?? sessionStorage.getItem(USER_KEY);
  return raw ? JSON.parse(raw) : null;
};

export const clearAuthSession = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
  sessionStorage.removeItem(TOKEN_KEY);
  sessionStorage.removeItem(USER_KEY);
};

export const isAuthenticated = () => Boolean(getAuthToken());
